import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ProductGrid from '../component/ProductGrid';
import Pager from '../component/Pager';
import { ProductContext } from '../context/ProductContext';

const ProductList = () => {
  const { categoryName } = useParams();
  const { products, loading, total, setFilters } = useContext(ProductContext);

  useEffect(() => {
    setFilters({ category: categoryName, search: '' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryName]);

  return (
    <div>
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-lg font-bold capitalize text-gray-900">{categoryName?.replace(/-/g, ' ')}</h2>
        <p className="text-sm text-gray-500">{total} products</p>
      </div>
      <ProductGrid products={products} loading={loading} />
      <Pager />
    </div>
  );
};

export default ProductList;
